import React, { useEffect } from 'react';
import {
  ListItem, ListItemText, TableRow, TableCell
} from '@material-ui/core';
import { MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import {
  getUIDateFormat, getUIDTFormat, useCtxParseValue, getEmptyValue, getApiDateFormat, getApiDTFormat
} from 'helpers';
import { makeStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { MUIDatePicker, MUIDateTimePicker } from 'components/FormHelpers/DatePicker';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { withChangeHandlers } from 'helpers/Change';
import Paper from '@material-ui/core/Paper';
import atoms from 'ctsutheme/components/atoms';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import { FarCalendarTimes, FarCalendarPlus } from 'assets/icons';

const { Divider, IconButton } = atoms;

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    width: 180
  },
  datePicker: {
    width: 180
  }
}));

const VersionDate = ({
  pioInfo, state, localDates, setState, handleDateChange
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleToggle = (event) => {
    setOpen(prevOpen => !prevOpen);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const id = open ? 'simple-popper' : undefined;

  const verDate = state ? state.versionDate : '';

  if (!_.isEmpty(verDate) && !_.includes(localDates, verDate)) localDates.push(verDate);

  const setVersionDate = (name, value) => {
    setState({
      ...state,
      [name]: value,
      pioChangeNumber: _.result(_.find(pioInfo,
        (obj) => obj.localDate === value),
      'pioChangeNumber')
    });
  };

  return (
    <>
      <MUISelect
        title="Version Date"
        value={verDate}
        className={`version-date-picker-wrapper ${classes.datePicker}`}
        name="versionDate"
        validators={['required']}
        errorMessages={['Required Field']}
        onChange={(ev) => {
          setVersionDate(ev.target.name, ev.target.value);
        }}
        InputProps={{
          name: 'versionDate',
          endAdornment:
  <IconButton
    aria-label="version picker"
    aria-describedby={id}
    onClick={handleToggle}
    title={open === true ? 'Close calendar date picker' : 'Open calendar date picker'}
  >
    {open === true ? <FarCalendarTimes /> : <FarCalendarPlus /> }
  </IconButton>
        }}
      >
        {_.map(localDates, (item, i) => (
          <ListItem
            key={_.uniqueId('versions_local_sel')}
            button
            value={item}
          >
            {item}
          </ListItem>
        ))}
      </MUISelect>
      <Divider />
      <Popper id={id} placement='bottom' anchorEl={anchorEl} open={open} transition disablePortal className="bg-white p-3 shadow-lg" style={{ zIndex: '1' }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper
              id="menu-list-grow"
              className={classes.root}
              style={{ width: 'auto' }}
            >
              {/* <ListItem
                key={_.uniqueId('versions_local_sel')}
                button
              /> */}
              <ListItem
                key={_.uniqueId('versions_local_sel')}
                // button
                style={{ padding: '0', paddingRight: '0' }}
              >
                <MUIDatePicker
                  title="Version Date Selector"
                  id="date-primary"
                  name="versionDate"
                  value={state ? getUIDateFormat(state.versionDate) : ''}
                  onChange={(event) => {
                    setVersionDate('versionDate', getApiDateFormat(event));
                  }}
                />
              </ListItem>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};


const VersionNumber = ({ versNumber, handleChange }) => (
  <MUITextBox
    title="Version Number"
    value={getEmptyValue(versNumber)}
    onChange={handleChange}
    validators={['maxStringLength:20']}
    errorMessages={['Maximum 20 characters allowed']}
    name="versionNo"
  />
);

const VersionDesc = ({
  versionDesc, handleChange, data
}) => (
  <MUITextBox
    title="Version Description"
    multiline
    rowsMax="2"
    // disabled={_.isEmpty(data)}
    value={getEmptyValue(versionDesc)}
    onChange={handleChange}
    validators={['required', 'maxStringLength:60']}
    errorMessages={['Required Field', 'Maximum 60 characters allowed']}
    name="versionDesc"
  />
);

const ReleaseDateTime = ({
 reviewType, activationDate, state, setState, data
}) => {
  const checkVal = ['NOT-RELEASED', 'NONE', 'UNKNOWN'];
  return (
    <MUIDateTimePicker
      title="Release Date Time"
      id="date-primary"
      name="activationDate"
      validators={checkVal.includes(reviewType) ? [] : ['required']}
      errorMessages={checkVal.includes(reviewType) ? [] : ['Required Field']}
      value={activationDate ? getUIDTFormat(activationDate) : ''}
      onChange={(event) => {
        let requiredByDate = state?.requiredByDate || '';
        if (_.isEmpty(data) && _.isEmpty(requiredByDate)) {
          requiredByDate = getApiDTFormat(event);
        } 
        setState({ ...state, activationDate: getApiDTFormat(event), requiredByDate });
      }}
      timeIntervals={15}
    />
  );
}

const EndDate = ({
  endDate, handleDateChange, isIrbExempt
}) => (
  <MUIDatePicker
    title="End Date"
    id="date-primary"
    name="endDate"
    disabled={isIrbExempt}
    value={endDate ? getUIDateFormat(endDate) : ''}
    onChange={handleDateChange('endDate')}
  />
);

const ReviewType = ({
  reviewType, handleChange, options, isIrbExempt
}) => (
  <MUISelect
    value={getEmptyValue(reviewType)}
    name="reviewType"
    disabled={isIrbExempt}
    onChange={handleChange}
    title="Review Type"
  >
    {_.map(options, (item, i) => (
      <ListItem
        button
        key={_.uniqueId('versions_reviewtype_sel')}
        value={item.enum_str}
      >
        <ListItemText primary={item.enum_str} />
      </ListItem>
    ))}
  </MUISelect>
);

const CollectType = ({
  state, collectType, handleChange, options, isIrbExempt
}) => (
  <MUISelect
    defaultValue={collectType}
    value={getEmptyValue(collectType)}
    name="collectType"
    disabled={isIrbExempt}
    onChange={handleChange}
    title="Collect Type"
  >
    {_.map(options, (item, i) => (
      <ListItem
        button
        key={_.uniqueId('versions_collecttype_sel')}
        value={item.enum_str}
      >
        <ListItemText primary={item.enum_str} secondary={item.comments} />
      </ListItem>
    ))}
  </MUISelect>
);

const checkIsDiableDateTime = (collectType, isIrbExempt, data) => {
  if (isIrbExempt && _.isEmpty(data)) {
    return false;
  }
  return (collectType !== 'REQUIRED');
}

const checkIsRequiredDateTime = (collectType) => (collectType === 'REQUIRED');

const ReqByDateTime = ({
  handleDateTimeChange, collectType, requiredByDate, disableCheck
}) => {
  return (
  <MUIDateTimePicker
    title="Required By Date & Time"
    id="requiredByDate-primary"
    name="requiredByDate"
    validators={checkIsRequiredDateTime(collectType) ? ['required'] : []}
    errorMessages={checkIsRequiredDateTime(collectType) ? ['Required Field'] : []}
    disabled={disableCheck}
    value={(requiredByDate && checkIsRequiredDateTime(collectType)) ? getUIDTFormat(requiredByDate) : ''}
    onChange={handleDateTimeChange('requiredByDate')}
    timeIntervals={15}
  />
);
}

const Comments = ({
  comments, handleChange
}) => (
  <MUITextBox
    title="Comments"
    margin="dense"
    multiline
    rowsMax="2"
    onChange={handleChange}
    value={getEmptyValue(comments)}
    validators={['maxStringLength:100']}
    errorMessages={['Maximum 100 characters allowed']}
    name="comments"
  />
);

const changeVersionDesc = (eve, setState, state, isIrbExempt, data) => {
  setState((prevState) => {
    if (isIrbExempt && !_.isEmpty(data)) {
      return { ...prevState, versionDesc: eve.target.value,  collectType: 'NO', requiredByDate: null};
    }
    return { ...prevState, versionDesc: eve.target.value };
  });
}

function Editversion(props) {
  const {
    state,
    handleChange,
    handleDateChange,
    handleDateTimeChange,
    cancel,
    reset,
    isIrbExempt,
    setState,
    data
  } = props;

  const {
    versionNo,
    versionDesc,
    activationDate,
    pioChangeNumber,
    collectType,
    reviewType,
    comments,
    requiredByDate,
    endDate
  } = state;

  const { protocolVersionCollType } = useCtxParseValue('LOV_VERSION_COLLECT_TYPE');
  const { protocolVersionRevType } = useCtxParseValue('LOV_VERSION_REVIEW_TYPE');
  if (isIrbExempt) {
    protocolVersionRevType.push({"enum_str":"EXEMPT","comments":"EXEMPT"});
  }

  useEffect(() => {
      if(isIrbExempt) {
        setState((prevState) => {
          if (_.isEmpty(prevState.collectType)) {
            return { ...prevState, collectType: _.isEmpty(data) ? 'REQUIRED' : 'NO',  reviewType: 'EXEMPT', endDate: null, versionDesc: _.isEmpty(data) ? 'Initial' : '' }
          }
          return { ...prevState };
        });
      }
  }, [isIrbExempt]);

  return (
    <TableRow className="state">
      <TableCell>{pioChangeNumber}</TableCell>
      <TableCell>
        <VersionNumber
          versNumber={versionNo}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <VersionDesc
          versionDesc={versionDesc}
          handleChange={(eve) => changeVersionDesc(eve, setState, state, isIrbExempt, data)}
          data={data}
        />
      </TableCell>
      <TableCell>
        <VersionDate {...props} />
      </TableCell>
      <TableCell>
        <ReleaseDateTime
          reviewType={reviewType}
          activationDate={activationDate}
          state={state}
          setState={setState}
          data={data}
        />
      </TableCell>
      <TableCell>
        <EndDate
          endDate={isIrbExempt ? null : endDate}
          handleDateChange={handleDateChange}
          isIrbExempt={isIrbExempt}
        />
      </TableCell>
      <TableCell>
        <ReviewType
          options={protocolVersionRevType}
          reviewType={reviewType}
          handleChange={handleChange}
          isIrbExempt={isIrbExempt}
        />
      </TableCell>
      <TableCell>
        <CollectType
          collectType={collectType}
          handleChange={handleChange}
          options={protocolVersionCollType}
          isIrbExempt={isIrbExempt}
        />
      </TableCell>
      <TableCell>
        <ReqByDateTime
          collectType={collectType}
          requiredByDate={requiredByDate}
          disableCheck={checkIsDiableDateTime(collectType, isIrbExempt, data)}
          handleDateTimeChange={handleDateTimeChange}
        />
      </TableCell>
      <TableCell>
        <Comments
          comments={comments}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>

  );
}

const EditVersions = compose(withChangeHandlers)(Editversion);


export { EditVersions };
